import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Bug, CheckCircle2 } from "lucide-react";

export default function AdminBugs() {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checked, setChecked] = useState(false);
  const [bugs, setBugs] = useState([]);
  useEffect(() => { if (user) api.get("/admin/whoami").then((r) => { setIsAdmin(!!r.data?.is_admin); setChecked(true); }).catch(() => setChecked(true)); }, [user]);
  const load = () => api.get("/admin/bugs").then((r) => setBugs(r.data)).catch(() => {});
  useEffect(() => { if (isAdmin) load(); }, [isAdmin]);
  if (!user) return <Navigate to="/login" />;
  if (checked && !isAdmin) return <div className="mx-auto max-w-lg px-6 py-24"><h1 className="text-3xl font-black tracking-tighter">Admins only.</h1></div>;
  const resolve = async (id) => { await api.post(`/admin/bugs/${id}/resolve`).catch(() => {}); toast.success("Marked resolved"); load(); };
  return (
    <div className="mx-auto max-w-4xl px-6 py-16">
      <div className="mono text-xs text-primary flex items-center gap-2"><Bug className="h-3 w-3" />admin · bug reports</div>
      <h1 className="mt-2 text-5xl font-black tracking-tighter">Reported bugs.</h1>
      <div className="mt-8 border border-border">
        {bugs.length === 0 ? <div className="p-10 text-center text-sm text-muted-foreground">No bugs reported.</div> : bugs.map((b, i) => (
          <div key={b.id} data-testid={`bug-${b.id}`} className={`p-5 ${i > 0 ? "border-t border-border" : ""} ${b.status === "resolved" ? "opacity-60" : ""}`}>
            <div className="flex items-center justify-between text-xs">
              <span className={`px-2 py-0.5 border uppercase tracking-widest ${b.status === "resolved" ? "border-primary text-primary" : "border-destructive text-destructive"}`}>{b.status}</span>
              <span className="mono text-muted-foreground">{new Date(b.created_at).toLocaleString()}</span>
            </div>
            <h3 className="mt-2 font-bold tracking-tight">{b.title}</h3>
            <p className="mt-1 text-sm text-muted-foreground whitespace-pre-wrap">{b.description}</p>
            <div className="mt-3 flex items-center justify-between text-xs">
              <span className="text-muted-foreground">by {b.reporter_name} · {b.reporter_email}{b.url ? ` · ${b.url}` : ""}</span>
              {b.status !== "resolved" && <Button size="sm" onClick={() => resolve(b.id)} data-testid={`resolve-${b.id}`} className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90"><CheckCircle2 className="mr-1 h-3 w-3" />Resolve</Button>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
